// src/components/Sidebar.js
import React from 'react';
import { HomeIcon, UsersIcon, ChartBarIcon, GiftIcon, MegaphoneIcon, CogIcon, StarIcon } from '@heroicons/react/24/outline';
import {Link, NavLink} from "react-router-dom"; // Example icons

const Sidebar = ({ userId, businessId }) => {
    const navItems = [
        { name: 'Dashboard', icon: HomeIcon, href: `/dashboard/${userId}/${businessId}/home` },
        { name: 'Loyalty Programs', icon: StarIcon, href: `/dashboard/${userId}/${businessId}/programs` },
        { name: 'Customers', icon: UsersIcon, href: `/dashboard/${userId}/${businessId}/customers` },
        { name: 'Analytics', icon: ChartBarIcon, href: `/dashboard/${userId}/${businessId}/analytics` },
        { name: 'Promotions', icon: GiftIcon, href: `/dashboard/${userId}/${businessId}/promotions` },
        { name: 'Communication', icon: MegaphoneIcon, href: `/dashboard/${userId}/${businessId}/communication` },
        { name: 'Settings', icon: CogIcon, href: `/dashboard/${userId}/${businessId}/settings` },
    ];

    return (
        <div className="w-64 bg-indigo-800 text-white flex flex-col min-h-screen shadow-lg">
            {/* LocalRewards Logo */}
            <div className="px-6 py-[18px] border-b border-indigo-700">
                <h2 className="text-3xl font-extrabold text-white">LocalRewards</h2>
            </div>

            {/* Navigation Links */}
            <nav className="flex-1 px-4 py-6">
                <ul className="space-y-4 mb-8">
                    {navItems.map((item, index) => (
                        <NavLink to={item.href} key={index}>
                            {({ isActive }) => (
                                <li className={`${isActive ? "bg-indigo-600 font-semibold" : ""} flex items-center space-x-3 px-4 py-2 rounded-lg text-indigo-100
                                 hover:bg-indigo-700 hover:text-white transition-colors duration-200 focus:outline-none
                                  focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-indigo-800
                            `}>
                                    <item.icon className="h-6 w-6" />
                                    <span className="text-lg">{item.name}</span>
                                </li>
                            )}
                        </NavLink>
                    ))}
                </ul>
            </nav>

            {/* Optional: User/Support link at bottom */}
            <div className="p-6 border-t border-indigo-700">
                <Link to={`/dashboard/${userId}/${businessId}/my-account`}
                      className="flex items-center space-x-3 text-indigo-100 hover:text-white hover:underline">
                    <UsersIcon className="h-5 w-5" />
                    <span>My Account</span>
                </Link>
            </div>
        </div>
    );
};

export default Sidebar;